/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const ArrowUp = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M20 10.3055L13.2328 3.5126C12.8941 3.17266 12.0039 2.25391 12.0039 2.25391C12.0039 2.25391 11.1094 3.16912 10.7672 3.5126L4 10.3055L5.05665 11.3662L11.2528 5.14648L11.2528 21H12.7472V5.14648L18.9433 11.3662L20 10.3055Z"
                        fill={color}
                    />
                </svg>
        );
    };
